module.exports = __webpack_public_path__ + "img/not_has_pic.a798603b.svg";